function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon-24x24-Address-Pin",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,2.84217094e-14 C17.5228475,2.84217094e-14 22,4.4771525 22,10 C22,13.3966932 19.3387133,17.5052498 14.0822587,22.4494959 L14.0822587,22.4494959 L13.3493899,23.1289028 C12.5853424,23.8273208 11.4146261,23.8273206 10.647966,23.1265056 L10.647966,23.1265056 L10.2794944,22.7872701 L9.56295951,22.1132217 C4.54295686,17.3195976 2,13.3208658 2,10 C2,4.4771525 6.4771525,2.84217094e-14 12,2.84217094e-14 Z M12,2 C7.581722,2 4,5.581722 4,10 C4,12.1932141 5.59531309,15.0578209 8.82266076,18.5251097 L8.82266076,18.5251097 L9.39191449,19.1253931 C9.7820843,19.5295008 10.1935979,19.9414289 10.6265101,20.361075 L10.6265101,20.361075 L11.2919341,20.9963198 L11.6366957,21.3182595 L11.9999705,21.6527107 L12.3532087,21.3275955 C12.4696043,21.2197023 12.5846589,21.1122881 12.6983734,21.0053544 L12.6983734,21.0053544 L13.364586,20.3695314 L13.9986764,19.7453163 C18.0159525,15.7258049 20,12.4466644 20,10 C20,5.581722 16.418278,2 12,2 Z M12,5 C14.7614237,5 17,7.23857625 17,10 C17,12.7614237 14.7614237,15 12,15 C9.23857625,15 7,12.7614237 7,10 C7,7.23857625 9.23857625,5 12,5 Z M12,7 C10.3431458,7 9,8.34314575 9,10 C9,11.6568542 10.3431458,13 12,13 C13.6568542,13 15,11.6568542 15,10 C15,8.34314575 13.6568542,7 12,7 Z",
  id: "Combined-Shape",
  fill: "#60CAA8",
  fillRule: "nonzero"
}));

var SvgAddress = function SvgAddress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/address.e2330798.svg";
export { ForwardRef as ReactComponent };